import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _reduce from 'lodash/reduce';
import React from 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';
import { safeRest, warn, rem } from '../../utils/functions.js';
import { SVG_ICON_SIZE_DEFAULT, MANULIFE_ICON_SIZE_DEFAULT } from './constants.js';
import ManulifeIcons from './ManulifeIcons/index.js';
import { SvgRoot, ManulifeRoot } from './styledComponents.js';

var _excluded = ["id", "manulifeName", "path", "color", "fill", "secondaryColor", "ariaHidden", "alt", "width", "height", "opacity"];
var Icon = function Icon(_ref) {
  var id = _ref.id,
    manulifeName = _ref.manulifeName,
    path = _ref.path,
    color = _ref.color,
    fill = _ref.fill,
    secondaryColor = _ref.secondaryColor,
    ariaHidden = _ref.ariaHidden,
    alt = _ref.alt,
    width = _ref.width,
    height = _ref.height,
    opacity = _ref.opacity,
    rest = _objectWithoutProperties(_ref, _excluded);
  var safeProps = safeRest(rest);

  // Check for duplication of mutually exclusive prop values; throw a warning if more than one is provided
  if (_reduce([path, manulifeName], function (acc, prop) {
    return prop ? acc + 1 : acc;
  }, 0) > 1) {
    warn('Icon', 'Only one of path or manulifeName should be provided. More than one has been provided.');
  }
  if (path) {
    return /*#__PURE__*/React.createElement(SvgRoot, _extends({
      src: path,
      alt: alt,
      "aria-hidden": ariaHidden,
      width: width || rem(SVG_ICON_SIZE_DEFAULT),
      height: height || rem(SVG_ICON_SIZE_DEFAULT),
      opacity: opacity
    }, safeProps));
  }
  if (manulifeName) {
    var ManulifeIcon = ManulifeIcons[manulifeName];
    return /*#__PURE__*/React.createElement(ManulifeRoot, _extends({}, safeProps, {
      color: color,
      fill: fill,
      secondaryColor: secondaryColor,
      width: width || rem(MANULIFE_ICON_SIZE_DEFAULT),
      height: height || rem(MANULIFE_ICON_SIZE_DEFAULT),
      "aria-hidden": ariaHidden,
      "data-icon": manulifeName,
      opacity: opacity
    }), /*#__PURE__*/React.createElement(ManulifeIcon, {
      id: id,
      alt: alt
    }));
  }
  return null;
};
process.env.NODE_ENV !== "production" ? Icon.propTypes = {
  /** DOM element id */
  id: PropTypes.string,
  /** name of icon (Manulife icon only) */
  manulifeName: PropTypes.string,
  /** icon color (Manulife icon only) */
  color: PropTypes.string,
  /** icon fill color (Manulife icon only) */
  fill: PropTypes.string,
  /** icon secondary color (Manulife icon only) */
  secondaryColor: PropTypes.string,
  /** path to svg icon, resource or data url */
  path: function path(props, propName) {
    var alt = props.alt,
      ariaHidden = props.ariaHidden;
    if (!alt && !ariaHidden) {
      return new Error("If using ".concat(propName, ", an alt prop must be set, or ariaHidden"));
    }
    return null;
  },
  /** alt text for svg icons */
  alt: PropTypes.string,
  /** aria-hidden attribute for svg icons */
  ariaHidden: PropTypes.bool,
  /** icon width (defaults to 1.25rem) */
  width: PropTypes.string,
  /** icon height (defaults to 1.25rem) */
  height: PropTypes.string,
  /** icon opacity; can take any value from 0 to 1 */
  opacity: PropTypes.number
} : void 0;
Icon.defaultProps = {
  id: undefined,
  manulifeName: '',
  path: '',
  color: 'inherit',
  fill: 'none',
  secondaryColor: 'none',
  alt: '',
  ariaHidden: true,
  width: null,
  height: null,
  opacity: 1
};
process.env.NODE_ENV !== "production" ? Icon.displayName = 'Icon' : void 0;
var Icon$1 = Icon;

export { Icon$1 as default };
